"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimelineItem = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = require("styled-components");
var __1 = require("../..");
var icons_1 = require("../../icons");
var Timeline_styled_1 = require("./Timeline.styled");
var TimelineItem = function (_a) {
    var title = _a.title, _b = _a.Icon, Icon = _b === void 0 ? react_1.default.createElement(icons_1.CheckFilled, null) : _b, children = _a.children, state = _a.state, context = _a.context, testId = _a.testId;
    var _c = (0, __1.useComponents)(), Heading3 = _c.Heading3, Small = _c.Small, P = _c.P;
    var colors = (0, styled_components_1.useTheme)().colors;
    return (react_1.default.createElement(Timeline_styled_1.TimelineListItem, { state: state, "data-testid": testId ? testId : 'timeline-list-item' },
        react_1.default.createElement(Timeline_styled_1.TimelineIcon, { state: state, "data-testid": "timeline-item-".concat(state) }, state === 'done' ? (react_1.default.createElement(icons_1.CheckFilled, { "data-testid": "timeline-item-complete", color: colors.success })) : (Icon)),
        react_1.default.createElement(Timeline_styled_1.TimelineHeadingWrapper, null,
            context ? (react_1.default.createElement(P, { as: Timeline_styled_1.TimelineContext, state: state },
                react_1.default.createElement(Small, null, context))) : null,
            react_1.default.createElement("div", null,
                react_1.default.createElement(Heading3, { as: Timeline_styled_1.TimelineHeading, state: state }, title),
                children))));
};
exports.TimelineItem = TimelineItem;
